import React from "react"
import ReactDOM from "react-dom"
import NewsListPageComponent from "./news-list-page-component"

export default class NewsListPageModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.newsItems = elem.dataset.newsItems && JSON.parse(elem.dataset.newsItems)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NewsListPageComponent {...self.modelJson} news={self.newsItems} />, self.elem)
  }
}
